/* eslint-disable linebreak-style */
import React from 'react';
const DeathStepShared = () => (
  <ol>
    <li>
    Attach a certified death certificate, showing cause of death, date of death, address, and other pertinent information for the deceased
    </li>
    <li>
    Proof of Outstanding Dues (invoice or other documentation received from developer)
    </li>
  </ol>
);

export default DeathStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/components/DeathStepShared.js